import React, { useState } from "react";
// import tw from "tailwind-styled-components";

// import makeAnimated from "react-select/animated";

// import { useNavigate } from "react-router-dom";

import RoomContainsOptions from "./RoomContainsOptions";
import RoomDoesNotContainsOptions from "./RoomDoesNotContainsOptions";




//Add new Data to floorData
const RoomFloors = ({
  roomOwnerMutate,
  roomEntryLoading,
  setRoomUser,
  selectedData,
  floorData,
  data,
  roomOptions,
}) => {
  return (
    <>
      {selectedData?.roomOptionId ? (
        <RoomContainsOptions
          setRoomUser={setRoomUser}
          selectedData={selectedData}
          roomEntryLoading={roomEntryLoading}
          clientId={data.clientId}
        />
      ) : (
        <RoomDoesNotContainsOptions
          setRoomUser={setRoomUser}
          selectedData={selectedData}
          roomEntryLoading={roomEntryLoading}
          apiData={data}
          roomOptions={roomOptions}
          roomOwnerMutate={roomOwnerMutate}
          roomOwnerLoading={roomEntryLoading}
        />
      )}
    </>
  );
};

export default RoomFloors;
